import React from "react";
import {
  DropOverride,
  PlateTypeCaptureProfile,
} from "../../../Model/CaptureProfile";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { ContinuousZoom } from "../../../Model/ImagerCapabilities";
import { PlateType } from "../../../Model/PlateType";
import DefaultImagingSettingCheckBox from "./DefaultImagingSettingCheckBox";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";

const DROP_OPTION_OVERRIDE_EXIST = "dropOptionOverrideExist";

type Props = {
  style?: React.CSSProperties;
  captureProfile: PlateTypeCaptureProfile;
  plateType: PlateType;
  setCaptureProfile: (captureProfile: PlateTypeCaptureProfile) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
  continuousZoom: ContinuousZoom;
  dropOptionOverrides: DropOverride[];
  disabled: boolean;
};

export default function ContinousZoomDropOverride({
  style = {},
  captureProfile,
  setCaptureProfile,
  onErrorCleared,
  onErrorOccur,
  plateType,
  continuousZoom,
  dropOptionOverrides,
  disabled,
}: Props) {
  const dropLocationCaptureProperty = captureProfile.dropLocation;

  if (captureProfile.dropLocation == null) {
    throw new Error("Drop location capture property is null");
  }

  if (dropLocationCaptureProperty == null) {
    throw new Error("Drop location capture property is null");
  }

  const numberOfDropPerWell = plateType.numberOfDropPerWell;
  const useDropOptionOverrides =
    captureProfile.dropLocation.dropOptionOverrideExist;

  const onDropOverrideChanged = (index: number, continuousZoom: number) => {
    let dropOverrides = [...dropOptionOverrides];
    dropOverrides[index] = {
      ...dropOptionOverrides[index],
      continuousZoom: continuousZoom,
    };
    setCaptureProfile({
      ...captureProfile,
      dropOverrides: dropOverrides,
    });
  };

  const onUseDropOverrideChanged = (dropOptionOverrideExist: boolean) => {
    let dropOverrides = [...dropOptionOverrides];
    setCaptureProfile({
      ...captureProfile,
      dropLocation: {
        ...dropLocationCaptureProperty,
        dropOptionOverrideExist: dropOptionOverrideExist,
      },
      dropOverrides: dropOverrides,
    });
  };

  let dropZoomOverrideInputs = [];
  if (dropLocationCaptureProperty.dropOptionOverrideExist) {
    for (let i = 0; i < numberOfDropPerWell; i++) {
      dropZoomOverrideInputs.push(
        <DefaultImagingSettingTextBox
          value={
            dropOptionOverrides != null && dropOptionOverrides.length > i
              ? dropOptionOverrides[i].continuousZoom ?? 0
              : 0
          }
          onChange={(name, value) => {
            onDropOverrideChanged(i, value);
          }}
          label={`Drop ${i + 1} Zoom`}
          name={EOpticAndCameraFeature.ContinuousZoom + "_override_drop_" + i}
          unit="x"
          min={continuousZoom.minContinuousZoom}
          max={continuousZoom.maxContinuousZoom}
          disabled={!useDropOptionOverrides}
          key={`drop-override-${i}`}
          style={{
            gridArea: `drop-${i}`,
          }}
          isInteger={false}
          onErrorOccur={(name) => onErrorOccur(name)}
          onErrorCleared={(name) => onErrorCleared(name)}
        />
      );
    }
  }

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <DefaultImagingSettingCheckBox
        checked={
          !disabled && dropLocationCaptureProperty.dropOptionOverrideExist
        }
        onChange={(name, value) => onUseDropOverrideChanged(value)}
        label="Override Zoom"
        name={DROP_OPTION_OVERRIDE_EXIST}
        disabled={disabled}
        style={{ margin: "24px 0px", fontWeight: "bold" }}
      />
      {!disabled && dropLocationCaptureProperty.dropOptionOverrideExist && (
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateAreas: `'drop-0 drop-1'
                              'drop-2 drop-3'`,
            gridTemplateColumns: "50% 50%",
            gridTemplateRows: "auto auto",
            gridRowGap: "5px",
            marginLeft: "0px",
            paddingLeft: "13px",
          }}
        >
          {dropZoomOverrideInputs}
        </div>
      )}
    </div>
  );
}
